import { Col, Form, Input, Row } from 'antd';
import React from 'react';

const { TextArea } = Input;

const TextOption = ({ question, selectOption }) => {

  return (
    <Row justify="center">
      <Col xxl={16} xl={18} lg={20} xs={20} sm={20} className="text-center mb-20">
        <Form>
          <Form.Item
            name='value'
            initialValue={question.selected_option?.value}
          >
            <TextArea
              style={{ height: 90, resize: 'none' }}
              placeholder="Ingrese su respuesta aquí"
              onBlur={(e) => selectOption(question, e.target.value)}
            />
          </Form.Item>
        </Form>
      </Col>
    </Row>
  )
}

export default TextOption;
